// authSlice
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const OPEN_LOADING = "OPEN_LOADING"
export const CLOSE_LOADING = "CLOSE_LOADING"
export const OPEN_TIMEOUT_DIALOG = "OPEN_TIMEOUT_DIALOG"
export const CLOSE_TIMEOUT_DIALOG = "CLOSE_TIMEOUT_DIALOG"
export const SAVE_MENU_STATUS = "SAVE_MENU_STATUS"

// authList
export const UPDATE_AUTH_LIST = "UPDATE_AUTH_LIST"
